
import ShreeDayStar from "../Charts/starLinePanaChart/7PM";
import ShreeNightStar from "../Charts/starLinePanaChart/8PM";

import MadhurDayStar from "../Charts/starLinePanaChart/12PM";
import MadhurNightStar from "../Charts/starLinePanaChart/1PM";

import MilanDayStar from "../Charts/starLinePanaChart/3PM";
import MilanNightStar from "../Charts/starLinePanaChart/4PM";

import RajdhaniDayStar from "../Charts/starLinePanaChart/5PM";
import RajdhaniNightStar from "../Charts/starLinePanaChart/6PM";

import KalyanStar from "../Charts/starLinePanaChart/10Am";
import KalyanNightStar from "../Charts/starLinePanaChart/11Am";

import TimeBazarStar from "../Charts/starLinePanaChart/9PM";
import MainBazarStar from "../Charts/starLinePanaChart/2PM";

import AllStarline from "../Charts/starLinePanaChart/AllStarline";


import ShreeDayJackpot from "../Charts/ShreeJackpot/7PM";
import ShreeNightJackpot from "../Charts/ShreeJackpot/8PM";

import MadhurDayJackpot from "../Charts/ShreeJackpot/12PM";
import MadhurNightJackpot from "../Charts/ShreeJackpot/1PM";

import MilanDayJackpot from "../Charts/ShreeJackpot/3PM";
import MilanNightJackpot from "../Charts/ShreeJackpot/4PM";

import RajdhaniDayJackpot from "../Charts/ShreeJackpot/5PM";
import RajdhaniNightJackpot from "../Charts/ShreeJackpot/6PM";

import KalyanJackpot from "../Charts/ShreeJackpot/10Am";
import KalyanNightJackpot from "../Charts/ShreeJackpot/11Am";

import TimeBazarJackpot from "../Charts/ShreeJackpot/9PM";
import MainBazarJackpot from "../Charts/ShreeJackpot/2PM";

import AllJackpot from "../Charts/ShreeJackpot/AllJackpot";


// ================= NORMALIZER =================
const normalize = (val) =>
  val?.replace(/\s+/g, "").toUpperCase();


// ================= STARLINE CONFIG =================
export const STARLINE_CHART_COMPONENTS = {

  [normalize("7:00 PM")]: ShreeDayStar,
  [normalize("8:00 PM")]: ShreeNightStar,

  [normalize("12:00 PM")]: MadhurDayStar,
  [normalize("1:00 PM")]: MadhurNightStar,

  [normalize("3:00 PM")]: MilanDayStar,
  [normalize("4:00 PM")]: MilanNightStar,

  [normalize("5:00 PM")]: RajdhaniDayStar,
  [normalize("6:00 PM")]: RajdhaniNightStar,

  [normalize("10:00 AM")]: KalyanStar,
  [normalize("11:00 AM")]: KalyanNightStar,

  [normalize("9:00 PM")]: TimeBazarStar,
  [normalize("2:00 PM")]: MainBazarStar,

  [normalize("ALL")]: AllStarline

};


// ================= JACKPOT CONFIG =================
export const JACKPOT_CHART_COMPONENTS = {

  [normalize("7:30PM")]: ShreeDayJackpot,
  [normalize("07:30PM")]: ShreeDayJackpot,

  [normalize("8:30PM")]: ShreeNightJackpot,
  [normalize("08:30PM")]: ShreeNightJackpot,

  [normalize("12:12PM")]: MadhurDayJackpot,
  [normalize("12:30PM")]: MadhurDayJackpot,
  [normalize("01:30PM")]: MadhurNightJackpot,

  [normalize("03:30PM")]: MilanDayJackpot,
  [normalize("04:30PM")]: MilanNightJackpot,

  [normalize("05:30PM")]: RajdhaniDayJackpot,
  [normalize("06:30PM")]: RajdhaniNightJackpot,

  [normalize("10:20AM")]: KalyanJackpot,
  [normalize("10:30AM")]: KalyanJackpot,
  [normalize("11:30AM")]: KalyanNightJackpot,

  [normalize("9:30PM")]: TimeBazarJackpot,
  [normalize("09:30PM")]: TimeBazarJackpot,

  [normalize("02:30PM")]: MainBazarJackpot,

  [normalize("ALL")]: AllJackpot

};